import { fairness } from "@/data/site";
import { FadeUp, Stagger } from "@/components/motion/Reveal";

export const Fairness = () => (
  <section data-testid="fairness-section" className="section border-t hairline bg-[color:var(--surface)]">
    <div className="container-x grid lg:grid-cols-12 gap-10">
      <div className="lg:col-span-5">
        <FadeUp><p className="eyebrow mb-4">Zusammenarbeit</p></FadeUp>
        <FadeUp delay={0.05}><h2 className="h-section">Damit Sie wissen, woran Sie sind.</h2></FadeUp>
        <FadeUp delay={0.1} className="lead mt-6 max-w-md">Verständliche Erklärungen, besprochene Kosten und Rücksprache vor Zusatzarbeiten: So möchten wir Vertrauen im Alltag verdienen.</FadeUp>
      </div>
      <Stagger className="lg:col-span-7 border-t hairline" gap={0.1}>
        {fairness.map((p, i) => (
          <div key={p.t} data-testid={`fairness-item-${i}`} className="grid sm:grid-cols-[48px_1fr] gap-2 sm:gap-6 py-7 border-b hairline">
            <span className="text-[13px] text-[color:var(--violet)] mono pt-1">0{i + 1}</span>
            <div>
              <h3 className="h-sub">{p.t}</h3>
              <p className="mt-2 text-[color:var(--ink-2)] leading-relaxed">{p.d}</p>
            </div>
          </div>
        ))}
      </Stagger>
    </div>
  </section>
);
